import axios from "@/libs/api.request";
// 获取列表
export const getList = params => {
  return axios.request({
    url: "/finance/ofExt",
    params,
    method: "get"
  });
};
// 创建列表
export const add = data => {
  return axios.request({
    url: "/finance/ofExt",
    data,
    method: "post"
  });
};
// 获取详情
export const getDetails = id => {
  return axios.request({
    url: `/finance/ofExt/${id}`,
    method: "GET"
  });
};
// 更新列表
export const update = data => {
  return axios.request({
    url: `/finance/ofExt/${data.id}`,
    method: "put",
    data
  });
};

// 删除列表
export const del = data => {
  return axios.request({
    url: `/finance/ofExt/${data.id}`,
    method: "DELETE"
  });
};

export const getConfig = data => {
  return axios.request({
    url: `/finance/ofExt/config`,
    method: "get",
  });
};